import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import {autobind} from 'core-decorators';

import {Page} from '../../common/components';
import {Metadata} from '../../common/metadata';
import {localURL, tryDecodeURI, window} from '../../common/util';

import {SearchTag} from '../components/Tag';

import {subscribe, transformProps} from '../../../replete';

@transformProps((props: jsx.Props) => {
    props.searchData = tryDecodeURI(props.match.params.searchData);

    return props;
})
@subscribe({
    exploreData: ['api.exploreterms.*', 'searchData'],
})
export class ExplorePage extends Page {
    searchTerms: string[] = [];

    pageChanged(nextProps: jsx.Props): boolean {
        return nextProps.searchData !== this.props.searchData;
    }
    propsNeedProcessing(nextProps: jsx.Props): boolean {
        for (const key of ['exploreData']) {
            if (nextProps[key] !== this.props[key]) {
                return true;
            }
        }
        return false;
    }
    pageInit(props: jsx.Props) {
        this.ttl = this.context.CONSTANTS.SEARCH_PAGE_TTL;

        this.searchTerms = props.searchData ?
            this.context.gtService.parseURLSearchTags(props.searchData) : [];
    }
    processNewProps(props: jsx.Props) {
        const gettextSub = this.context.gtService.gettextSub;

        if (!props.searchData) {
            return;
        }
        const body = props.exploreData;
        if (body.status === 500) {
            this.context.response.status = 500;
            return;
        }
        if (!body.results.length) {
            this.context.response.status = 404;
            return;
        }
        if (localURL(body.results[0].url).substr(0, 8) === '/search/') {
            this.context.response.status = 404;
            return;
        }
        this.context.response.status = 200;
        const exploreData = this.props.exploreData.results[0];

        const titleFragment = exploreData?.name;
        // Translators: This is the page title.
        this.title = gettextSub('The popular {titleFragment} GIFs everyone\'s sharing', {titleFragment});
        this.h1_title = gettextSub('{titleFragment} GIFs', {titleFragment});
        this.description = gettextSub('All the popular {titleFragment} animated GIFs for your conversation. Discover and Share the best GIFs on Tenor.', {titleFragment});
        this.keywords = `${exploreData?.name.replace(' ', ',')},gifs,explore,memes`;

        window.fbq('track', 'ViewContent', {content_name: this.title});
    }
    @autobind
    renderExploreDataSearch(tag: api.ExploreTerm) {
        return <div className="responsive-tag-wrapper" key={tag.searchterm}>
            <SearchTag
                tag={{
                    ...tag,
                    url: localURL(tag.url),
                }}
            />
        </div>;
    }
    @autobind
    renderExploreDataNestedsearch(search: api.NestedExploreTerm) {
        return <div>
            <h2>{search.name}</h2>
            <div className="responsive-tag-container">
                {search.searches.map(this.renderExploreDataNestedsearchSearch)}
            </div>
        </div>;
    }
    @autobind
    renderExploreDataNestedsearchSearch(tag: api.ExploreTerm) {
        return <div className="responsive-tag-wrapper" key={tag.searchterm}>
            <SearchTag tag={tag} />
        </div>;
    }
    @autobind
    renderExploreDataQuote(tag: api.ExploreTermQuote) {
        return <div className="responsive-tag-wrapper" key={tag.url}>
            <SearchTag tag={{
                ...tag,
                name: `"${tag.quote}"`,
            }} />
        </div>;
    }
    renderPage() {
        const gettextSub = this.context.gtService.gettextSub;
        const exploreData = this.props.exploreData.results[0];
        return (
            <div className="ExplorePage container page">
                <Metadata page={this}/>
                <div className="center-container heading-wrapper">
                    { exploreData && <h1>{exploreData.name}</h1> }
                </div>
                {this.props.searchData && <div className="center-container explore">
                    { exploreData?.searches?.length > 0 && <div>
                        <div className="responsive-tag-container">
                            {exploreData.searches.map(
                                this.renderExploreDataSearch)}
                        </div>
                    </div> }
                    { exploreData?.nestedsearches?.map(
                        this.renderExploreDataNestedsearch)}
                    { exploreData?.quotes?.length > 0 && <div>
                        <h2>
                            {gettextSub('Popular {name} Quotes', {name: exploreData.name})}
                        </h2>
                        <div className="responsive-tag-container">
                            {exploreData.quotes.map(
                                this.renderExploreDataQuote)}
                        </div>
                    </div>}
                </div>}
            </div>
        );
    }
}


@transformProps((props: jsx.Props) => {
    props.searchData = '';

    return props;
})
@subscribe({
    exploreData: ['api.exploreterms.*', 'searchData'],
})
export class ExploreHomePage extends Page {
    propsNeedProcessing(nextProps: jsx.Props) {
        for (const key of ['exploreData']) {
            if (nextProps[key] !== this.props[key]) {
                return true;
            }
        }
        return false;
    }
    pageInit(props: jsx.Props) {
        const gettextSub = this.context.gtService.gettextSub;

        this.title = gettextSub('Explore GIFs - Tenor GIF Keyboard');
        this.description = gettextSub('Say more with Tenor. Find the perfect Animated GIFs and videos to convey exactly what you mean in every conversation.');
        this.keywords = 'gifs,search gifs,share gifs,memes,explore';

        window.fbq('track', 'ViewContent', {content_name: this.title});
    }
    @autobind
    renderExploreDataSearch(tag: api.ExploreTerm, i: number) {
        const localizeUrlPath = this.context.gtService.localizeUrlPath;
        const {searchterm, url} = tag;
        const localizedUrl = url ?
            localizeUrlPath(localURL(url)) : this.linkToSearch([searchterm]);
        return <div key={i} className="responsive-tag-wrapper">
            <SearchTag
                tag={{
                    ...tag,
                    url: localizedUrl,
                }}
            />
        </div>;
    }
    renderPage() {
        const gettextSub = this.context.gtService.gettextSub;
        const exploreData = this.props.exploreData.results[0];

        return <div className="ExploreHomePage container page">
            <Metadata page={this} />
            <h1>{gettextSub('Explore GIFs')}</h1>
            <div className="responsive-tag-container">
                {exploreData?.searches?.map(this.renderExploreDataSearch)}
            </div>
        </div>;
    }
}
